import React from 'react';

import '../Tutorial.css';
import TutorialGirl from "../TutorialGirl";
import Typewriter from "typewriter-effect";

function T82BossWindowSecond() {


    const text = 'Lesson two — independent work. Come on, I believe in you.'
    return (
        <div>

            <div className={'BossWindow30Top'}></div>
            <div className={'clickBoss20Right'}></div>
            <div className={'BossWindow30Left'}></div>

            <TutorialGirl position={'Right'} undressingProcess={2}/>
            <div className='tutorialContainer tutorialTopContainer'>
                <div className='tutorialBottomTextField'><Typewriter
                    options={{
                        delay: 30
                    }}
                    onInit={(typewriter) => {
                        typewriter.typeString(text).start();
                    }}
                /></div>
            </div>
        </div>

    );
}

export default T82BossWindowSecond;